news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 프레임아웃과 손잡고 AI 기반 디지털 혁신 추진</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌,&nbsp;프레임아웃과 손잡고 AI&nbsp;기반 디지털 혁신 추진</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>- ‘교육 콘텐츠·브랜드 디자인·고객 커뮤니케이션’&nbsp;전반에 생성형 AI&nbsp;기술 적용</strong></span>
                              </p>
                              <p><span style="font-family:'맑은 고딕';"><strong>- LLM&nbsp;챗봇 구축부터 이미지 생성·콘텐츠 자동화까지 전방위 협력 추진</strong></span>
                              </p>
                              <p>&nbsp;</p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250605144305.jpg"></figure>
                              <p><span style="font-family:'맑은 고딕';">사진설명:&nbsp;에듀윌 양형남 대표(좌측)와 프레임아웃 노해영 대표가 업무협약서에 서명하고,&nbsp;기념촬영을 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">(2025-05-16) 종합교육기업 에듀윌(대표 양형남)이 통합 디지털 에이전시 프레임아웃(대표 노해영)과 손잡고 </span><span
                                  style="color:black;font-family:'맑은 고딕';">AI&nbsp;기반의&nbsp;</span><span
                                  style="font-family:'맑은 고딕';">디지털 혁신에 나선다고 16일 밝혔다.&nbsp;</span></p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">양사는 15일,&nbsp;서울 구로구 에듀윌 본사에서 업무협약(MOU)을 체결하고,&nbsp;프레임아웃의 AI&nbsp;브랜드 경험 솔루션을 에듀윌의 콘텐츠 기획 및 제작,&nbsp;고객 커뮤니케이션,&nbsp;브랜드 디자인 전반에 도입하기로 했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">협약식에는 에듀윌 양형남 대표와 허승재 COO,&nbsp;프레임아웃 노해영 대표와 구자호 AXC(AI eXperience Center)&nbsp;센터장 등 주요 관계자가 참석했다. &nbsp;</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">프레임아웃은 생성형 AI&nbsp;기반의 브랜드 경험 혁신을 이끄는 디지털 솔루션 기업이다.&nbsp;특히 자체 개발한 ‘ConversAI’, ‘IdentiVis’, ‘AutoPageAI’&nbsp;등 AI&nbsp;솔루션을 에듀윌의 비즈니스에 최적화된 플랫폼으로 재구성하여 콘텐츠 기획 및 제작,&nbsp;고객 커뮤니케이션,&nbsp;브랜드 디자인 자동화 등 다양한 분야에서 AI&nbsp;기반의 실질적 혁신을 제공한다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 협약을 통해 양사는 △LLM(Large Language Model,&nbsp;대형 언어 모델)&nbsp;기반 챗봇 구축 및 상담 UI&nbsp;개발 △AI&nbsp;이미지 생성 기술 도입 △콘텐츠 페이지 자동 생성 및 배포 시스템 구축 △공동 기술 개발 및 테스트 운영 등 여러 분야에서 협력한다.&nbsp;이를 통해 에듀윌은 교육 콘텐츠 제작부터 고객 대응,&nbsp;브랜드 디자인에 이르는 전 영역에 AI를 적용해 플랫폼의 효율성과 경쟁력을 끌어올릴 계획이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">양형남 에듀윌 대표는 “이번 협업은 에듀윌의 교육 콘텐츠와 서비스 전반에 AI&nbsp;기술을 본격 도입하는 출발점이 될 것”이라며, “프레임아웃과의 시너지를 통해 학습 경험을 혁신하고,&nbsp;내부 업무 효율과 고객 만족도를 동시에 높여가겠다”고 말했다.&nbsp;</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">노해영 프레임아웃 대표 역시 “AXC는 생성형 AI를 통해 브랜드 경험의 새로운 가능성을 실현해 나가는 혁신 허브”라며 “에듀윌과 함께 교육 분야에서 실질적인 AI&nbsp;혁신 사례를 만들어가겠다”고 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌과 프레임아웃은 이번 협력을 시작으로 교육 분야의 디지털 전환을 선도하며,&nbsp;고객 중심의 AI&nbsp;기반 서비스 확대에 박차를 가할 방침이다.</span>
                              </p>
                              <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news25" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, AI교육기업으로 대전환 선언…“전국민 AI 성공시대 연다”</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news23" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 공인중개사 교재로 온라인서점 1위부터 22위까지 석권… ’수험서 시장 평정’</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
